import React from 'react';
import { connect } from 'react-redux';
import { titleCase } from '../../lib/urlTools';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const SuburbPropertyCounts = props => {
  const {
    suburb: {
      status,
    } = {},
    showLearnMoreLink = false,
    isForSRP = false,
    isForAll = false,
    isForSaleAndSold = false,
    isForRent = false,
  } = props;

  if (status !== 'success') {
    return null;
  }

  const {
    suburb: {
      suburb_detail: {
        address: {
          suburb: suburbName,
          postcode,
          stateCode,
        } = {},
        currentRecentSalesCount,
        currentSaleListingCount,
        currentRentalListingCount,
      } = {},
    } = {}
  } = props;

  const forSalePropertiesCountDescription = `${currentSaleListingCount > 0 ? currentSaleListingCount : 'no'}  propert${currentSaleListingCount === 1 ? 'y' : 'ies'}`;
  const forRentPropertiesCountDescription = `${currentRentalListingCount > 0 ? currentRentalListingCount : 'no'}  propert${currentRentalListingCount === 1 ? 'y' : 'ies'}`;
  const recentSalePropertiesCountDescription = `${currentRecentSalesCount > 0 ? currentRecentSalesCount : 'no'}  propert${currentRecentSalesCount === 1 ? 'y' : 'ies'}`;

  const suburbSearchUrl = `${stateCode.toLowerCase()}/${suburbName.toLowerCase().replace(/-/ig, '--').replace(/ /ig, '-').replace(/\\s/ig, '-')}-${postcode}`;
  const forSaleSearchLink = `/property-for-sale/${suburbSearchUrl}`;
  const forRentSearchLink = `/property-for-rent/${suburbSearchUrl}`;
  const recentlySoldSearchLink = `/sold/${suburbSearchUrl}`;
  const suburbProfileLink = `/suburb/${suburbSearchUrl}`;

  const renderForPDPandSuburbProfile = () =>
    <React.Fragment>
      {(!isForSRP || (isForSRP && isForAll)) &&
        <div>
          There are currently <Link to={forSaleSearchLink} target="_blank">{forSalePropertiesCountDescription} listed
          for sale</Link>, and&nbsp;
          <Link to={forRentSearchLink} target="_blank">{forRentPropertiesCountDescription} listed for
            rent</Link> in {titleCase(suburbName)} on OnTheHouse.
          According to Cotality&apos;s data, <Link to={recentlySoldSearchLink} target="_blank">{recentSalePropertiesCountDescription} were
          sold</Link> in the past 12 months
          in {titleCase(suburbName)}. {showLearnMoreLink &&
          <Link to={suburbProfileLink} target="_blank">Learn more about {titleCase(suburbName)}</Link>}
        </div>
      }
    </React.Fragment>;

  const renderForSRP = () =>
    <React.Fragment>
      {isForSRP && isForSaleAndSold &&
        <React.Fragment>
          There are currently <Link to={forSaleSearchLink} target="_blank">{forSalePropertiesCountDescription} listed
          for sale</Link> in {titleCase(suburbName)}, and&nbsp;
          <Link to={recentlySoldSearchLink} target="_blank">{recentSalePropertiesCountDescription} properties have
          sold</Link> in the past 12 months. {showLearnMoreLink &&
          <Link to={suburbProfileLink} target="_blank">Learn more about {titleCase(suburbName)}</Link>}
        </React.Fragment>
      }

      {isForSRP && isForRent &&
        <React.Fragment>
          There are currently <Link to={forRentSearchLink} target="_blank">{forRentPropertiesCountDescription} listed for
          rent</Link> in {titleCase(suburbName)}. {showLearnMoreLink &&
          <Link to={suburbProfileLink} target="_blank">Learn more about {titleCase(suburbName)}</Link>}
        </React.Fragment>
      }
    </React.Fragment>;

  return (
    <React.Fragment>
      { renderForPDPandSuburbProfile() }
      { renderForSRP() }
    </React.Fragment>
  );
};

SuburbPropertyCounts.propTypes = {
  suburb: PropTypes.object,
  showLearnMoreLink: PropTypes.bool,
  isForAll: PropTypes.bool,
  isForSRP: PropTypes.bool,
  isForSaleAndSold: PropTypes.bool,
  isForRent: PropTypes.bool,
};

const mapStateToProps = (state) => ({suburb: state.suburb});

export default connect(mapStateToProps)(SuburbPropertyCounts);
